import { PolygonCategoryConfigs } from "~map-style-utils/types/__generated/gql/graphql";
import { LayerProps } from "react-map-gl/maplibre";

export const getPolygonCategoryStyle = (
	configs: PolygonCategoryConfigs,
): LayerProps[] => {
	const { valueField, symbolStyle, symbolValues } = configs;

	const styles: LayerProps[] = [];

	// Fill
	if (symbolStyle?.fill?.fillType === "solid") {
		styles.push({
			id: "solid-fill-filling",
			type: "fill",
			paint: {
				// @ts-ignore
				"fill-color": [
					"match",
					["to-string", ["get", valueField!]],
					...symbolValues!.flatMap(({ value, symbol }) => [
						value!,
						symbol!.fill!.color!,
					]),
					"#ffffff",
				],
				"fill-opacity": symbolStyle?.fill?.opacity ?? 1,
			},
		});
	} else if (symbolStyle?.fill?.fillType !== "none") {
		styles.push({
			id: "pattern-fill-filling",
			type: "fill",
			paint: {
				// @ts-ignore
				"fill-pattern": [
					"match",
					["to-string", ["get", valueField!]],
					...symbolValues!.flatMap(({ value, symbol }) => [
						value!,
						`${symbolStyle?.fill?.fillType}-pattern-${symbol?.fill?.color}`,
					]),
					`${symbolStyle?.fill?.fillType}-pattern`,
				],
				"fill-opacity": symbolStyle?.fill?.opacity ?? 0,
			},
		});
	}

	// Stroke
	if (symbolStyle?.stroke?.style === "solid") {
		styles.push({
			id: "solid-stroke-casing",
			type: "line",
			layout: {
				"line-cap": "round",
				"line-join": "round",
			},
			paint: {
				"line-color": symbolStyle?.stroke?.color ?? "#000000",
				"line-width": symbolStyle?.stroke?.width ?? 0,
				"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
			},
		});
	}

	if (symbolStyle?.stroke?.style === "dash") {
		styles.push(
			{
				id: "dash-stroke-casing",
				type: "line",
				layout: {
					"line-cap": "round",
					"line-join": "round",
				},
				paint: {
					"line-color": "#000000",
					"line-width": (symbolStyle?.stroke?.width ?? 0) * 4,
					"line-dasharray": [
						symbolStyle?.stroke?.width ?? 0,
						symbolStyle?.stroke?.width ?? 0,
					],
					"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
				},
			},
			{
				id: "dash-stroke-filling",
				type: "line",
				layout: {
					"line-cap": "round",
					"line-join": "round",
				},
				paint: {
					"line-color": symbolStyle?.stroke?.color ?? "#000000",
					"line-width": symbolStyle?.stroke?.width ?? 0,
					"line-dasharray": [
						(symbolStyle?.stroke?.width ?? 0) * 4,
						(symbolStyle?.stroke?.width ?? 0) * 4,
					],
					"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
				},
			},
		);
	}

	if (symbolStyle?.stroke?.style === "dot") {
		const width = symbolStyle?.stroke?.width ?? 0;

		styles.push(
			{
				id: "dot-stroke-casing",
				type: "line",
				layout: {
					"line-cap": "round",
					"line-join": "round",
				},
				paint: {
					"line-color": symbolStyle?.stroke?.color ?? "#000000",
					"line-width": width,
					"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
					"line-dasharray": [0, width],
				},
			},
			{
				id: "dot-stroke-filling",
				type: "line",
				layout: {
					"line-cap": "round",
					"line-join": "round",
				},
				paint: {
					"line-color": symbolStyle?.stroke?.color ?? "#000000",
					"line-width": width,
					"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
					"line-dasharray": [0, width],
				},
			},
		);
	}

	return styles;
};
